import {
    Waves,
    Infinity,
    CloudRain,
    Sun,
    Footprints,
    Dumbbell,
    ShieldCheck,
    Flower2,
    Flame,
    PartyPopper,
    Trophy,
    FlagTriangleRight,
    ArrowUpDown,
    Sunset,
    BookOpen,
    Projector,
    ConciergeBell,
    Umbrella,
    Utensils,
    Thermometer,
    MoonStar,
    Baby,
    Car,
    DoorOpen,
    Gamepad2,
    Sparkles,
    Fan,
    Music,
    Dog,
    Warehouse,
    Landmark,
    CloudFog,
    Briefcase,
    Salad,
    CheckCircle2,
    Trees,
    Bike,
    Building,
    Home,
    Building2
} from 'lucide-react';

export const ICON_MAPPING: Record<string, React.ElementType> = {
    // Amenities
    'Swimming Pool': Waves,
    'Infinity Pool': Infinity,
    'Splash Pad': CloudRain,
    'Pool Deck': Sun,
    'Jacuzzi': Waves,
    'Foot Bath': Footprints,
    'Aquatic Gym': Dumbbell,
    'Indoor Gym': Dumbbell,
    'Security': ShieldCheck,
    'Garden': Trees,
    'BBQ Area': Flame,
    'Reflexology Path & Aroma Garden': Footprints,
    'Outdoor Party Hall': PartyPopper,
    'Jogger Arena': Bike,
    'Cricket Pitch': Trophy,
    'Badminton Court': Trophy,
    'Mini Golf': FlagTriangleRight,
    'Elevator': ArrowUpDown,
    'Sea/Water View': Sunset,
    'Library': BookOpen,
    'Open Air Cinema': Projector,
    'Concierge Service': ConciergeBell,
    'Beach Access': Umbrella,
    'Fully Fitted Kitchen': Utensils,
    'Sauna': Thermometer,
    'Prayer Room': MoonStar,
    "Children's Pool": Baby,
    'Shallow Pool': Waves,
    'Floating Cabana': Umbrella,
    'Pool Party Area': PartyPopper,
    'Private Jacuzzi': Waves,
    'Gym': Dumbbell,
    'Outdoor Gym': Dumbbell,
    'Parking': Car,
    'Balcony': DoorOpen,
    "Children's Play Area": Gamepad2,
    'BBQ Garden': Flame,
    'Indoor Party Hall': PartyPopper,
    "Kid's Daycare": Baby,
    'Yoga Deck': Flower2,
    'Football Court': Trophy,
    'Basketball Court': Trophy,
    'Sparklz Garden': Sparkles,
    'Central AC': Fan,
    'Spa': Sparkles,
    'Zumba Dance': Music,
    'Pet-Friendly': Dog,
    'Basement': Warehouse,
    'View of Landmark': Landmark,
    'Steam Room': CloudFog,
    'Business Center': Briefcase,
    'Health Bar': Salad,

    // Property Types (Generic additions for future usage)
    'Apartment': Building,
    'Villa': Home,
    'Townhouse': Home,
    'Penthouse': Building2,
    'Bunglow': Home,
    'Compound': Building
};

export const DEFAULT_ICON = CheckCircle2;
